import React from 'react'
import { Route } from 'react-router-dom'
import { FormsCreate, FormsEdit, FormsMain, FormsView, IndexForms } from '../Views/Web/FormServ/Forms'
import { InsFormsCreate, InsFormsEdit, InsFormsMain, InsFormsView, InsIndexForms } from '../Views/Web/FormServ/InspectionForms'

function FormRoutes() {
    return (
      <Route path="forms" element={<FormsMain />}>

      <Route path="surveyforms" element={<FormsMain />}>
           <Route index element={<IndexForms/>} />
           <Route path='create' element={<FormsCreate/>} />
           <Route path='edit/:formsEditId' element={<FormsEdit/>} />
           <Route path='view/:formsViewId' element={<FormsView/>} />
         
          
      </Route>
      <Route path="insforms" element={<InsFormsMain />}>
           <Route index element={<InsIndexForms/>} />
           <Route path='create' element={<InsFormsCreate/>} />
           <Route path='edit/:formsEditId' element={<InsFormsEdit/>} />
           <Route path='view/:formsViewId' element={<InsFormsView/>} />
         
          
      </Route>
      </Route>
    )
  }
  
  export default FormRoutes